module.exports = __webpack_public_path__ + "img/18.4420cc5d.png";